import axios from 'axios';
// import mock from './rexMockData';

const API_URL = '/api/campaigns';

export function resetErrors() {
  return dispatch => dispatch({ type: 'REX_RESET_ERRORS' });
}

export function getRexGifts() {
    return dispatch => {
    dispatch({ type: 'REX_FETCHING' });

    return axios.get(API_URL)
      .then(
        response => {
          const campaigns =
            response.data && response.data.campaigns ?
              response.data.campaigns : [];
          dispatch({ type: 'REX_GIFTS', gifts: campaigns });
        }
      ).catch(err => {
        if (err.response) {
          // The request was made and the server responded with an error status code
          if (err.response.data.Error) {
            dispatch({ type: 'REX_ERROR', error: err.response.data.Error });
          } else {
            dispatch({ type: 'REX_ERROR', error: 'UNKNOWN' });
          }
        } else if (err.request) {
          // The request was made but no response was received
          dispatch({ type: 'REX_ERROR', error: 'UNKNOWN' });
        } else {
          // Something happened in setting up the request that triggered an Error
          dispatch({ type: 'REX_ERROR', error: 'UNKNOWN' });
        }
    });
  };
}

export function resetGifts() {
  return dispatch => dispatch({ type: 'REX_RESET' });
}

export function orderGifts(data) {
  return dispatch => {

    return axios.post(API_URL, data)
      .then(
        response => {
          dispatch({ type: 'REX_SUBMIT', data: response.data });
        }
      )
      .catch(err => {
        if (err.response) {
          // The request was made and the server responded with an error status code
          if (err.response.data.Error) {
            dispatch({type: 'REX_SUBMIT_ERROR', error: err.response.data.Error});
          } else {
            dispatch({type: 'REX_SUBMIT_ERROR', error: 'UNKNOWN'});
          }
        } else if (err.request) {
          // The request was made but no response was received
          dispatch({type: 'REX_SUBMIT_ERROR', error: 'UNKNOWN'});
        } else {
          // Something happened in setting up the request that triggered an Error
          dispatch({type: 'REX_SUBMIT_ERROR', error: 'UNKNOWN'});
        }
      });
  };
}



// WEBPACK FOOTER //
// ./web/js/stores/actions/rex.js